// extracted by mini-css-extract-plugin
export default {"title_box":"AdvantagesComponent_title_box__-cIIU","img_box":"AdvantagesComponent_img_box__9gb07","app":"AdvantagesComponent_app__Ttdc2"};